import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'

import PcbLayerCount from 'components/form/pcbLayerCount/index'
import { createNamedReducer } from 'helpers/ReducerUtil'
import { createNamedAction } from 'helpers/ActionUtil'
import pcbLayerCountReducer from './reducer'
import injectReducer from 'helpers/injectReducer'
import getSelectors from './selectors'
import { updateLayerCount } from './actions'
import {
  getPath,
  combinePath
} from 'containers/Form/util'

const withReducer = (path, id) => {
  const valuePath = getPath(path, id)
  const reducer = createNamedReducer(valuePath, pcbLayerCountReducer)

  return injectReducer(valuePath, reducer)
}

const withConnect = (path, id) => {
  const combinedPath = combinePath(path, id)
  const valuePath = getPath(path, id)
  const updateLayerCountAction = createNamedAction(valuePath, updateLayerCount)

  const {
    valuesSelector,
    labelSelector,
    minLayerCountSelector,
    maxLayerCountSelector
  } = getSelectors(combinedPath)

  const mapStateToProps = (state) => {
    return {
      label: labelSelector(state),
      layerCount: valuesSelector(state),
      minLayerCount: minLayerCountSelector(state),
      maxLayerCount: maxLayerCountSelector(state)
    }
  }

  const mapDispatchToProps = (dispatch) => {
    return {
      onLayerCountChange: (layerCount) => {
        dispatch(updateLayerCountAction(layerCount))
      }
    }
  }

  return connect(mapStateToProps, mapDispatchToProps)
}

export { default as PcbLayerCount } from 'components/form/pcbLayerCount/index'
export {
  withConnect,
  withReducer
}

export default R.curry((path, id) => R.compose(
  withReducer(path, id),
  withConnect(path, id)
)(PcbLayerCount))
